import React from "react";
import { Notify } from "../../services/custom/Messages";
import { notification } from "antd";
import { FrownOutlined, SmileOutlined } from "@ant-design/icons";

export const openNotification = (message, description, type) => {
  const key = "nys";
  const maxDuration = 15;
  const minDuration = 7;

  const customNotificationStyle = {
    backgroundColor:
      type === Notify.ERROR
        ? "#d65944"
        : type === Notify.WARNING
        ? "#e58231"
        : "#6cbf43",
    border:
      type === Notify.ERROR
        ? "2px solid #a82e1a"
        : type === Notify.WARNING
        ? "2px solid #934c14"
        : "2px solid #3d7720",
    color: "#FFFFFF",
    fontWeight: "bold",
    wordWrap: 'break-word',
    wordBreak: 'break-word',
  };

  notification.config({
    placement: "topRight",
    bottom: 50,
    duration: Notify.ERROR ? maxDuration : minDuration,
    rtl: true,
    maxCount: 2,
  });

  notification[type]({
    key,
    message: message,
    description: description,
    style: customNotificationStyle,
    icon: type === Notify.ERROR ? <FrownOutlined /> : <SmileOutlined />
  });
};

// export default openNotification;
